import styled, { keyframes } from 'styled-components';

const rise = keyframes`
  from { opacity: 0; transform: translateY(12px); }
  to { opacity: 1; transform: translateY(0); }
`;

const spin = keyframes`
  to { transform: rotate(360deg); }
`;

const shimmer = keyframes`
  from { transform: translateX(-100%); }
  to { transform: translateX(100%); }
`;

export const SsoWrapper = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px 16px;
  background: radial-gradient(circle at 50% 0%, #fff1e7 0%, #f6f6f6 55%);
  font-family: Inter, sans-serif;

  .sso-card {
    width: 100%;
    max-width: 440px;
    padding: 40px 32px 32px;
    border-radius: 16px;
    background: #fff;
    box-shadow: 0 18px 48px rgba(8, 8, 8, 0.08), 0 2px 6px rgba(8, 8, 8, 0.04);
    text-align: center;
    animation: ${rise} 0.45s ease-out both;
  }

  .sso-title {
    margin: 28px 0 6px;
    font-size: 20px;
    font-weight: 700;
    line-height: 28px;
    color: #080808;
  }

  .sso-subtitle {
    margin: 0 0 24px;
    font-size: 14px;
    line-height: 20px;
    color: #5c5c5c;
  }

  .sso-steps {
    margin: 0 0 24px;
    padding: 0;
    list-style: none;
    text-align: left;
  }

  .sso-step {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 8px 0;
    font-size: 14px;
    color: #909090;
    transition: color 0.3s ease;

    &.is-active {
      color: #080808;
      font-weight: 500;
    }

    &.is-done {
      color: #3b3b3c;
    }
  }

  .sso-step-icon {
    display: grid;
    place-items: center;
    width: 20px;
    height: 20px;
    flex: none;
    border-radius: 50%;
    border: 2px solid #d3d3d3;
    font-size: 11px;
    color: #fff;
    transition: background 0.3s ease, border-color 0.3s ease;
  }

  .sso-step.is-active .sso-step-icon {
    border-color: #ffdbc6;
    border-top-color: #fc8543;
    animation: ${spin} 0.8s linear infinite;
  }

  .sso-step.is-done .sso-step-icon {
    border-color: #009e1f;
    background: #009e1f;
  }

  .sso-progress {
    position: relative;
    height: 4px;
    overflow: hidden;
    border-radius: 4px;
    background: #ececec;
  }

  .sso-progress-fill {
    position: relative;
    height: 100%;
    overflow: hidden;
    border-radius: 4px;
    background: linear-gradient(90deg, #f79f6f, #fc8543);
    transition: width 0.6s ease;

    &::after {
      content: '';
      position: absolute;
      inset: 0;
      background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.6), transparent);
      animation: ${shimmer} 1.2s ease-in-out infinite;
    }
  }

  .sso-error-icon {
    display: inline-grid;
    place-items: center;
    width: 56px;
    height: 56px;
    border-radius: 50%;
    background: #fdeaea;
    color: #d92929;
    font-size: 22px;
  }

  .sso-actions {
    display: flex;
    justify-content: center;
    gap: 12px;
  }

  @media (prefers-reduced-motion: reduce) {
    .sso-card,
    .sso-step-icon,
    .sso-progress-fill::after {
      animation: none !important;
    }
  }
`;

export default SsoWrapper;
